<template>
  <a-card size="small" title="地域分布图">
    <div class="area-chart">
      <e-chart
        style="width: 100%; height: 100%;"
        :options="options"
        autoresize
        dom-id="opensource-area-chart" />
    </div>
  </a-card>
</template>

<script>
export default {
  name: 'AreaChart',
  props: {
    data: Object,
  },
  computed: {
    options () {
      const { areas = {}, countries = {}, provinces = {} } = this.data
      const seriesData1 = []
      const seriesData2 = []
      const seriesData3 = []
      Object.keys(areas).forEach(key => {
        seriesData1.push({ name: key, value: areas[key] })
      })
      Object.keys(countries).forEach(key => {
        seriesData2.push({ name: key, value: countries[key] })
      })
      Object.keys(provinces).forEach(key => {
        seriesData3.push({ name: key.replace('中国/', ''), value: provinces[key] })
      })
      seriesData1.sort((a, b) => a.value - b.value)
      seriesData2.sort((a, b) => a.value - b.value)
      seriesData3.sort((a, b) => a.value - b.value)
      return {
        series: [
          {
            type: 'pie',
            radius: '40%',
            center: ['50%', '50%'],
            label: {
              formatter: '{b}：{c}',
              position: 'outer',
              alignTo: 'none',
              bleedMargin: 5,
            },
            left: 0,
            right: '66.667%',
            top: 0,
            bottom: 0,
            data: seriesData1,
          },
          {
            type: 'pie',
            radius: '40%',
            center: ['50%', '50%'],
            label: {
              formatter: '{b}：{c}',
              position: 'outer',
              alignTo: 'none',
              bleedMargin: 5,
            },
            right: '33.333%',
            left: '33.333%',
            top: 0,
            bottom: 0,
            data: seriesData2,
          },
          {
            type: 'pie',
            radius: '40%',
            center: ['50%', '50%'],
            label: {
              formatter: '{b}：{c}',
              position: 'outer',
              alignTo: 'none',
              bleedMargin: 5,
            },
            right: '2%',
            left: '66.667%',
            top: 0,
            bottom: 0,
            data: seriesData3,
          },
        ],
      }
    },
  },
}
</script>

<style lang="less" scoped>
.area-chart {
  height: 500px;
  ::v-deep {
    .echarts {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
